// extracted by mini-css-extract-plugin
export default {"footerContainer":"Footer_footerContainer__Vhpn8","ulContainer":"Footer_ulContainer__TMNyO","icon":"Footer_icon__S1RTh"};